module.exports = __webpack_public_path__ + "img/logo.7ecaf70c.svg";